import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/users/logistic-manager/new',
  title: 'Cadastro Gestor Logístico',
  endpoint: '/app/person',
}
